import type { FC, ReactNode } from 'react'

interface BrandMarkProps {
    className?: string
}

/* The arched doorway mark used in the header, footer and favicon. Inherits the current text color. */
export const BrandMark: FC<BrandMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 40 40'
            fill='none'
            aria-hidden='true'
            className={className}
        >
            <path d='M12 33V19a8 8 0 0 1 16 0v14' stroke='currentColor' strokeWidth='2.25' strokeLinecap='round' />
            <path d='M17 33v-8.5a3 3 0 0 1 6 0V33' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' opacity='0.5' />
            <path d='M7 33h26' stroke='currentColor' strokeWidth='2.25' strokeLinecap='round' />
        </svg>
    )
}
